function ContactSection() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 pb-16 md:px-6">
      <div className="rounded-lg border border-background-200/70 bg-background-50 p-6 md:p-10">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-mail-send-line"></i> 联系我们
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
              建议、投稿或合作，欢迎来信
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              如果你有想分享的剧情解读、角色考据，或是对网站的任何建议，都可以通过下面的方式找到我们。我们会认真阅读每一条反馈。
            </p>
            <div className="mt-6 space-y-4">
              <div className="flex items-center gap-4">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-mail-line text-lg"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">投稿与合作</p>
                  <a href="mailto:hello@manga-fans.example" className="text-sm font-medium text-foreground-950 hover:text-primary-700">
                    hello@manga-fans.example
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                  <i className="ri-chat-smile-line text-lg"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">读者反馈</p>
                  <a href="mailto:feedback@manga-fans.example" className="text-sm font-medium text-foreground-950 hover:text-primary-700">
                    feedback@manga-fans.example
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-lg bg-secondary-100 p-6">
            <span className="inline-flex items-center gap-2 text-xs font-medium text-secondary-700">
              <i className="ri-double-quotes-l"></i> 读者口碑
            </span>
            <blockquote className="mt-4 font-heading text-lg font-bold leading-relaxed text-foreground-900">
              「在嘿咻嘿咻漫画资讯站读了几篇剧情解析，终于把之前没看懂的伏笔串起来了，追更体验直接翻倍。」
            </blockquote>
            <p className="mt-4 text-sm text-foreground-600">—— 一位忠实读者</p>
            <div className="mt-6 flex flex-wrap gap-3">
              {["结局考据", "角色档案", "读者圆桌"].map((t) => (
                <span key={t} className="rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-secondary-800">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;